/**
 * Icon Rollover. Laying the groundwork for custom cover and contain functionality.
 */
(function($) {
    let iconRollover        = '.wp-block-cd-icon-rollover';
    let rolloverBackground  = iconRollover + ' .background';
    let $iconRollover       = $(iconRollover);
    let activeClass         = 'is-activated';

    function scaleBanners() {
        $iconRollover.each(function() {
            let bannerHeight = $(this).find('.icon').height();
            let bannerWidth = $(this).find('.icon').width(); 

            let $image = $(this).find('.background');
            let imageWidth = $image.get(0).naturalWidth;
            let imageHeight = $image.get(0).naturalHeight;

            let newDimensions = imgFitDimensions(imageWidth, imageHeight, bannerWidth, bannerHeight);

            let scaleFactorX = newDimensions['width'] / bannerWidth;
            let scaleFactorY = newDimensions['height'] / bannerHeight;

            $image.css('transform', 'scale(' + scaleFactorX + ', ' + scaleFactorY + ')' );

            if( !$(this).hasClass('loaded') ) {
                $(this).addClass('loaded');
            }
        });
    }

    $(document).ready(function() {
        scaleBanners(); 
        $iconRollover.each(function() {
            let isTapped            = false;
            let isDragging          = false;

            let $currentRollover = $(this);
            let $rolloverLink = $(this).find('> a');
            
            $rolloverLink.on({
                focus: function() {
                    $currentRollover.addClass(activeClass);
                    $(this).addClass('is-tapped');
                },
                blur: function() {
                    $currentRollover.removeClass(activeClass);
                    $(this).removeClass('is-tapped');
                },
                touchstart: function() {
                    isTapped = true;
                },
                touchmove: function() {
                    isDragging = true;
                },
                touchend: function(event) {
                    if( isTapped && !isDragging ) {
                        if( !$(this).hasClass('is-tapped') ) {
                            event.preventDefault();
                        }
                        $(this).focus();
                        isTapped = false;
                    } else {
                        $(this).blur();
                    }
                },
                mouseup: function(event) {
                    if( isTapped ) {
                        event.preventDefault();
                    }
                }
            });
        });
    });

    $(window).on('resize', function() {
        scaleBanners(); 
    });

    $(window).on('load', function () {
        // Make sure banners are still scaled if arrive fails for some reason
        scaleBanners();
    });

})(jQuery);